import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio916 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M15.1992 7C15.1992 6.33726 14.6618 5.7998 13.999 5.7998H9.99902C9.33628 5.7998 8.79883 6.33726 8.79883 7V17L8.80566 17.123C8.8673 17.728 9.37784 18.2002 9.99902 18.2002H13.999C14.6618 18.2002 15.1992 17.6627 15.1992 17V7ZM16.7988 17C16.7988 18.5464 15.5454 19.7998 13.999 19.7998H9.99902C8.54924 19.7998 7.3572 18.6981 7.21387 17.2861L7.19922 17V7C7.19922 5.4536 8.45263 4.2002 9.99902 4.2002H13.999C15.5454 4.2002 16.7988 5.4536 16.7988 7V17Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio916);
export default ForwardRef;
